export class DecodeVinResponse {
  constructor(
    public vin = '',
    public make: string[] = [],
    public model: string[] = [],
    public year: string[] = [],
    public trim: string[] = [],
    public inserviceDate = '',
    public inserviceDateFound = false,
    public odometer = '',
    public vehicleCondition = '',
    public cartFound = false,
    public status = false,
    public message = '',
    public manualDecode = false,
    public loadQuote = false
  ) {}
}
